<template>
    <div style="background-color: white" class="card-body">
        <el-row :gutter="30">
            <el-col :span="20" v-for="classx in $parent.cell.classes" :key="classx.id">
                <div style="text-align: center;border: 2px solid rgb(141, 193, 245);margin-bottom: 2px;opacity:0.5" :style="{'background-color':classx.color}">
                    <div :style="{'color':'black'}">
                        {{classx.class}}<br>
                        {{classx.teacher}}<br>
                        {{classx.classroom_name}}<br>
                        {{classx.status_name}}
                    </div>

                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "Dialog_ClassDetail",
        data() {
            return {
            }
        },
        created() {
        },
    }
</script>

<style scoped>

</style>